import ai from './ai';
import auth from './auth';
import alerts from './alerts';
import calendar from './calendar';
import common from './common';
import nav from './nav';
import news from './news';
import onboarding from './onboarding';
import notices from './notices';
import overview from './overview';
import plans from './plans';
import portfolio from './portfolio';
import profile from './profile';
import server from './server';
import settings from './settings';
import signals from './signals';
import social from './social';
import ws from './ws';

export default { ai, auth, alerts, calendar, common, nav, news, notices, onboarding, overview, plans, portfolio, profile, server, settings, signals, social, ws };
